if (typeof FeaturedReviews === 'undefined') {
    class FeaturedReviews extends HTMLElement {
        constructor() {
            super();
            this.autoplayDelay = this.hasAttribute('data-autoplay-delay') ? parseInt(this.getAttribute('data-autoplay-delay')) : false;
        }

        connectedCallback() {

            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            whenReady('Swiper', () => {
                try {

                    this.swiper = new Swiper(swiperContainer, {
                        a11y: true,
                        slidesPerView: 1,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        autoplay: {
                            enabled: this.autoplayDelay ? true : false,
                            delay: this.autoplayDelay,
                            disableOnInteraction: false,
                        },
                        mousewheel: {
                            enabled: !window.isSafari(),
                            forceToAxis: window.isSafari() ? false : true,
                            thresholdDelta: 10
                        },
                        modules: [Swiper.Mousewheel, Swiper.Autoplay, Swiper.A11y, Swiper.EffectFade],
                    });


                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {

            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

    }

    if (!window.customElements.get('featured-reviews')) {
        window.customElements.define('featured-reviews', FeaturedReviews);
    }
}